import {
  GET_CATALOG,
  GET_USER_CATALOG,
  SET_LEARN_FORMATION,
} from "../actions/formationLearner.actions";

const initialState = { catalog: [], userCatalog: [], current: null };

export default function formationLearnerReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CATALOG:
      return { ...state, catalog: action.payload };
    case GET_USER_CATALOG:
      return { ...state, userCatalog: action.payload };
    case SET_LEARN_FORMATION:
      return { ...state, current: action.payload };
    default:
      return state;
  }
}
